// Proprietary minimap view extension
// Registers the custom element for use in zoom-toolbar

import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { effects } from './effects';

export class EdgelessMinimapViewExtension extends ViewExtensionProvider {
  override name = 'edgeless-minimap';

  override effect() {
    super.effect();
    effects();
  }

  override setup(_context: ViewExtensionContext) {
    super.setup(_context);
    // No widget registration - minimap is embedded in zoom-toolbar
  }
}
